import React from "react";
import { Rocket } from "lucide-react";

// ml-2 inline-flex items-center bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full

function PlannedPill() {
    return (
        <div className="ml-3 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-50 text-purple-700">
            <Rocket className="w-3.5 h-3.5 mr-1" />
            Planned
        </div>
    );
}

export default PlannedPill;
